<template>
  <div class="notifications-settings-item">
    <h4 class="text-sm text-text-label mb-2">{{ title }}</h4>
    <p class="text-sm text-text-ternary mb-4">{{ subtitle }}</p>
    <div class="mb-4">
      <BaseToggle :checked="setting.push"
                  size="lg"
                  @change="$emit('update',{name:'push',value:!setting.push})">
        {{ $t('pushLabel') }}
      </BaseToggle>
    </div>
    <div>
      <BaseToggle :checked="setting.email"
                  size="lg"
                  @change="$emit('update',{name:'email',value:!setting.email})">
        {{ $t('emailLabel') }}
      </BaseToggle>
    </div>
  </div>
</template>

<script>
import BaseToggle from "@/components/UI/BaseToggle";

export default {
  name: "NotificationsSettingsItem",
  components: {BaseToggle},
  props: {
    title: String,
    subtitle: String,
    setting: Object
  },
  data() {
    return {
      a: true,
      b: true
    }
  },
  i18n: {
    messages: {
      en: {
        pushLabel: 'Push-notifications',
        emailLabel: 'Email'
      },
      ru: {
        pushLabel: 'Push-уведомления',
        emailLabel: 'Email'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications-settings-item {
  /deep/ .toggle {
    label {
      @apply text-2sm text-text-secondary;
    }
  }
}
</style>